import { render } from "./addTags.vue?vue&type=template&id=6af67b40"
import script from "./addTags.vue?vue&type=script&lang=js"
export * from "./addTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__